/** Orden de grupos en la barra lateral. */
export const CHANNEL_SIDEBAR_ORDER = [
  'testchat',
  'demo',
  'whatsapp_js',
  'whatsapp_meta',
  'messenger',
  'instagram',
  'telegram',
  'web',
  'web_widget',
  'slack',
  'sms_twilio',
  'email',
  'teams',
] as const;

export function channelLabel(ch: string): string {
  const m: Record<string, string> = {
    testchat: 'Testchat',
    demo: 'Demo',
    web: 'Web',
    web_widget: 'Chat web',
    messenger: 'Messenger',
    instagram: 'Instagram',
    whatsapp_js: 'WhatsApp · QR (whatsapp-web.js)',
    whatsapp_meta: 'WhatsApp · Meta (Cloud API)',
    telegram: 'Telegram',
    slack: 'Slack',
    sms_twilio: 'SMS (Twilio)',
    email: 'Email',
    teams: 'Microsoft Teams',
  };
  return m[ch] ?? ch;
}

export function channelSortKey(ch: string): number {
  const i = CHANNEL_SIDEBAR_ORDER.indexOf(ch as (typeof CHANNEL_SIDEBAR_ORDER)[number]);
  return i === -1 ? 100 + ch.charCodeAt(0) : i;
}

/** Etiqueta del proveedor de IA en burbujas (alineada con el backend / lista). */
export function agentSourceLabel(source: string | null | undefined): string {
  if (!source) return '';
  if (source === 'openai') return 'OpenAI';
  if (source === 'anthropic') return 'Anthropic';
  if (source === 'deepseek') return 'DeepSeek';
  if (source === 'workflow') return 'Flujo';
  if (source === 'semantic') return 'Atajo guía';
  if (source === 'rules') return 'Reglas';
  if (source === 'handoff') return 'Handoff';
  if (source === 'plugin') return '🔌 Plugin';
  if (source === 'unconfigured') return 'Sin clave API';
  if (source === 'human') return 'Humano';
  return source;
}

/** Formatea el agentModel para mostrar en la UI. Convierte "plugin:calendar" → "📅 Calendario" */
export function formatAgentModel(model: string | null | undefined): string {
  if (!model) return '';
  const m = model.trim();
  if (m.startsWith('plugin:calendar→')) {
    return `📅 Calendario (${m.slice('plugin:calendar→'.length)})`;
  }
  if (m.startsWith('plugin:s3→')) {
    return `📁 Archivos (${m.slice('plugin:s3→'.length)})`;
  }
  if (m === 'plugin:calendar') return '📅 Calendario';
  if (m === 'plugin:s3') return '📁 Archivos';
  if (m === 'plugin') return 'Plugin';
  return model;
}
